module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/nft3-2fcb9d23595b2c093947c8f86fa87f68.png";